export enum AdManagerEvents {
  ENTITY_EVENT_UPDATE_STATUS = 'advertising/entityEvents/updateStatus',
  ENTITY_EVENT_METRICS_GRID_FILTER_UPDATED = 'advertising/entityEvents/updateMetricsGridFilter',
  ENTITY_EVENT_METRICS_GRID_ACTION_CLICKED = 'advertising/entityEvents/metricsGridActionClicked',
  ENTITY_EVENT_METRICS_GRID_FILTER_TOGGLED = 'advertising/entityEvents/metricsGridFilterToggled',
  ENTITY_EVENT_SELECT_SA_ACTION = 'advertising/entityEvents/selectSAAction'
}
